import React, {useEffect, useRef, useState} from 'react';
import {GoogleMap, Marker, useLoadScript} from '@react-google-maps/api';
import { GOOGLE_MAPS_CONFIG } from '../../../../constants/GoogleMapsConfig';
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import {Dimensions, Pressable, Text, TextInput} from "react-native";

const mapContainerStyle = {
    height: '500px',
    width: '100%',
    borderRadius: '20px',
    overflow: 'hidden',
};

const center = {
    lat: -34.397,
    lng: 150.644,
};

const options = {
    disableDefaultUI: true,
    zoomControl: true,
};

const WIDTH = Dimensions.get('window').width;
const ADDRESS_LEVEL_ZOOM = 25;

const Libraries = ['places'];

// TO-DO: Fix the input box overflow issue.
// TO-DI: Switch from "Use Current Location" to "..." to show users it's retrieving the current location.
const GoogleMapsComponent = ({camp, setCamp}) => {
    const [selected, setSelected] = useState(
        ('campAddress' in camp) ? {lat: camp.lat, lng: camp.lng} : null
    );
    const {isLoaded} = useLoadScript(GOOGLE_MAPS_CONFIG);
    const [address, setAddress] = useState(camp.campAddress);
    const [fetching, setFetching] = useState(false);

    const mapRef = useRef();

    useEffect(() => {
        if (isLoaded) {
            const autocomplete = new google.maps.places.Autocomplete(
                document.getElementById('autocomplete') as HTMLInputElement,
                {types: ['address']}
            );

            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                if (place.geometry) {
                    setSelected({
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                    });

                    if (mapRef.current) {
                        mapRef.current.panTo(place.geometry.location);
                    }

                    setAddress(place.formatted_address);

                    const [street, city, state_zipcode, country] = place.formatted_address.split(",");
                    const [state, zipcode] = state_zipcode.trim().split(" ");

                    setCamp((prevState) => ({
                        ...prevState,
                        campAddress: place.formatted_address,
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                        street: street,
                        city: city,
                        state: state,
                        zipcode: zipcode,
                        country: country,
                    }));
                }


            });
        }
    }, [isLoaded]);

    const handleUseCurrentLocation = async () => {
        if (navigator.geolocation) {
            setFetching(true);

            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const {latitude, longitude} = position.coords;
                    setSelected({lat: latitude, lng: longitude});
                    if (mapRef.current) {
                        mapRef.current.panTo({lat: latitude, lng: longitude});
                    }

                    // Reverse geocode to get address
                    const geocoder = new google.maps.Geocoder();
                    const result = await geocoder.geocode({location: {lat: latitude, lng: longitude}});

                    if (result.results[0]) {
                        const address = result.results[0].formatted_address;
                        setAddress(address);

                        const [street, city, state_zipcode, country] = address.split(",");
                        const [state, zipcode] = state_zipcode.trim().split(" ");

                        setCamp((prevState) => ({
                            ...prevState,
                            campAddress: address,
                            lat: latitude,
                            lng: longitude,
                            street: street,
                            city: city,
                            state: state,
                            zipcode: zipcode,
                            country: country,
                        }));
                    }

                    setFetching(false);
                },
                (error) => {
                    console.error("Error getting the current location", error);
                    setFetching(false);
                }
            );
        } else {
            console.error("Geolocation is not supported by this browser.");
        }
    };

    return (
        <div style={{width: '100%', height: '100%'}}>
            {isLoaded ? (
                <>
                    <GoogleMap
                        mapContainerStyle={mapContainerStyle}
                        zoom={ADDRESS_LEVEL_ZOOM}
                        center={selected || center}
                        options={options}
                        onLoad={(map) => (mapRef.current = map)}
                    >
                        {selected && <Marker position={selected}/>}
                    </GoogleMap>

                    <div
                        style={{
                            position: 'absolute',
                            top: '160px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '85%',
                            maxWidth: WIDTH * 0.65,
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#fff',
                            borderRadius: '20px',
                            border: '2px solid black',
                            boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                            zIndex: 1,
                        }}
                    >
                        <MaterialCommunityIcons style={{
                            marginLeft: '20px',
                            marginRight: '10px',
                        }} name={'map-marker'} size={25} color="black"/>
                        <TextInput
                            id="autocomplete"
                            type="text"
                            placeholder="Enter your camp location"
                            value={address}
                            onChangeText={setAddress}
                            style={{
                                flex: 1,
                                height: '40px',
                                border: 'none',
                                outline: 'none',
                                padding: '10px',
                                borderRadius: '20px',
                                fontSize: '18px',
                                color: '#333',
                            }}
                        />
                    </div>

                    <Pressable
                        onPress={handleUseCurrentLocation}
                        style={{
                            position: 'absolute',
                            bottom: '20px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            backgroundColor: 'black',
                            border: 'none',
                            paddingHorizontal: 10,
                            paddingVertical: 10,
                            borderRadius: '20px',
                            cursor: 'pointer',
                            boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
                        }}
                    >
                        <Text style={{color: 'white', fontWeight: 'bold'}}>
                            {fetching ? 'Fetching Current Location...' : 'Use Current Location'}
                        </Text>
                    </Pressable>
                </>
            ) : (
                <div>Loading...</div>
            )}
        </div>
    );
};

export default GoogleMapsComponent;
